// extracted by mini-css-extract-plugin
export var createdDate = "_k8-1";
export var divider = "_k8-2";
export var headerDivider = "_k8-3";
export var messagesCard = "_k8-0";
export var messagesContainer = "_k8-6";
export var messagesContainerWrapper = "_k8-4";
export var showLeftPanelButton = "_k8-8";
export var topButtons = "_k8-7";
export var withPadding = "_k8-5";